import React from "react";
import { S3_HOST } from "@/_constant";
import { useLanguageContext } from "@/hooks";
import { Category } from "@/types";

interface CategoryItemProps {
    category: Category,
    onClick: (category: Category) => void
};
const CategoryItem: React.FC<CategoryItemProps> = ({ category, onClick }) => {
    const { language } = useLanguageContext();

    return (
        <div className="text-center">
            <a onClick={(e) => onClick(category)}>
                <img src={S3_HOST + category?.thumbnail_url} className="img-fluid rounded" style={{width: "8rem", height: "8rem"}}/>
                <p>{language(category?.displayCode)}</p>
            </a>
        </div>
    );
}

export default CategoryItem;